import $ from "jquery";
import { getCookie, setCookie } from "./Helper";

export class Alert extends React.Component {
    constructor(props) {
        super();    
        this.state = {
            alertCollection: props.initialNotificationList
        };
    }

    componentDidMount() {


        switch (this.getUrlVars()['msg']) {
            case 'successOrder':
                var alertMessage = {
                    type: "primary",
                    message: 'Order Complete - Thank you!'
                };
                this.doUpdate({}, alertMessage);
                break;

            case 'newAbconet':
                var alertMessage = {
                    type: "primary",
                    message: <div>NetConnect is now Abconet there are new <a href="/features/">features</a> and a new design. Please login with your <strong>email address</strong> to continue.</div>
                };
                this.doUpdate({}, alertMessage);
                break;

            case 'orderComplete':
                var alertMessage = {
                    type: "primary",
                    message: <div>Your order has been placed.</div>
                };
                this.doUpdate({}, alertMessage);
                break;
                

            case 'ociFail':
                var alertMessage = {
                    type: "danger",
                    message: <div>Error with OCI Punchout login.</div>
                };
                this.doUpdate({}, alertMessage);
                break;
        }

        $(document).on('AlertUpdated', this.doUpdate.bind(this));
    }    

    doUpdate(ev, alert) {
        var alertCollection = this.state.alertCollection;
        alertCollection.push(alert);
        this.setState({
            alertCollection: alertCollection
        });     
    }

    renderAlert(alert) {
        var button = null;

        if (alert.id != null) {
            if (getCookie("alert-" + alert.id)) {
                return null;
            }

            button = <button onClick={this.closeAlert.bind(this, alert)} className="close"><span aria-hidden="true">&times;</span></button>;
        }

        return <div className="container">
                   <div className={`alert alert-${alert.type}`} role="alert">
                        {alert.message} {button}
                   </div>
               </div>;
    }

    closeAlert(alert) {
        var alertCollection = this.state.alertCollection;
        alertCollection.pop(alert);
        this.setState({
            alertCollection: alertCollection
        });
        setCookie("alert-" + alert.id, true);
    }

    render() {
        return this.state.alertCollection.map(this.renderAlert.bind(this));
    }

    getUrlVars() {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for (var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }
}